import React from 'react';
import styles from './Products.module.css';

const Products: React.FC = () => {
  const mockProducts = [
    { id: 1, name: '메모리 드로어', price: 29900, stock: 50, category: '가구', status: '판매중' },
    { id: 2, name: '메모리 드로어 프리미엄', price: 39900, stock: 25, category: '가구', status: '판매중' },
    { id: 3, name: '메모리 드로어 미니', price: 19900, stock: 0, category: '가구', status: '품절' },
  ];

  return (
    <div className={styles.adminProducts}>
      <h1>상품 관리</h1>
      <div className={styles.productsHeader}>
        <button className={styles.btnAddProduct}>+ 새 상품 추가</button>
      </div>
      <div className={styles.productsTableContainer}>
        <table className={styles.productsTable}>
          <thead>
            <tr>
              <th>ID</th>
              <th>상품명</th>
              <th>가격</th>
              <th>재고</th>
              <th>카테고리</th>
              <th>상태</th>
              <th>액션</th>
            </tr>
          </thead>
          <tbody>
            {mockProducts.map(product => (
              <tr key={product.id}>
                <td>{product.id}</td>
                <td>{product.name}</td>
                <td>₩{product.price.toLocaleString()}</td>
                <td>
                  <span className={`${styles.stockBadge} ${product.stock > 0 ? styles.inStock : styles.outOfStock}`}>
                    {product.stock}
                  </span>
                </td>
                <td>{product.category}</td>
                <td>
                  <span className={`${styles.statusBadge} ${product.status === '판매중' ? styles.selling : styles.soldOut}`}>
                    {product.status}
                  </span>
                </td>
                <td>
                  <button className={styles.btnEdit}>수정</button>
                  <button className={styles.btnDelete}>삭제</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Products;
